import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#000000'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: '#cccccc',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        color:'#666666',
        textAlign: 'left',
        fontFamily:'HelveticaBold',
        flexGrow: 1,
    },
    type: {
        width: '33%',
        paddingLeft: 8,
    },
    qty: {
        width: '33%',
        textAlign: 'right',
    },
    price: {
        width: '33%',
        textAlign: 'right',
        paddingRight: 8,
    },
  });

  const InvoiceTableHeader = () => (
    <View style={styles.container}>
        <Text style={styles.type}>Type</Text>
        <Text style={styles.qty}>Quantity</Text>
        <Text style={styles.price}>Price</Text>
    </View>
  );
  
  export default InvoiceTableHeader
